export const tileRowGap = 5;

export const desktopAspectX = '3';
export const desktopAspectY = '5';
export const desktopAspect = `${desktopAspectX} / ${desktopAspectY}`;

export const mobileAspectX = '1';
export const mobileAspectY = '2';
export const mobileAspect = `${mobileAspectX} / ${mobileAspectY}`;

// Slightly shorter tile aspects for the hide-price treatment — reclaims the dead space
// where the price label used to sit. Value prop cards (ValuePropCard) still use the
// standard ratio, so rows containing them will have a height mismatch (expected).
export const treatmentDesktopAspect = '3.15 / 4.5';
export const treatmentMobileAspect = '1.05 / 1.8';
